export const isChatEnabled = () => process.env.REACT_APP_CHAT_ENABLED === 'true';